import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export const usePingEntityLeaseMutation = (onError?: (errorMessage: string) => void) => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (existingLeaseGuid: string) => {
            const response = await zoneApiClient.pingEntityLease(existingLeaseGuid);
            if (!response?.httpResponse.ok) {
                if (response.errorMessage && response.httpResponse.status == 400) {
                    if (response.errors?.length ?? 0 > 0) {
                        throw new Error(
                            `Failed to ping entity lease: ${response.errors[0].message}`
                        );
                    }
                }
                throw new Error('Failed to ping entity lease');
            }
            return response.payload;
        },
        onError(error) {
            if (error instanceof Error && typeof onError === 'function') {
                onError(error.message);
            }
        },
    });
}
    